// store/features/productCriteriaSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productType: '',
  searchKeyword: '',
  startDate: '',
  endDate: '',
  selectedProduct: null,
  selectedInteraction: null, // add this too, if used
};

const productCriteriaSlice = createSlice({
  name: 'productCriteria',
  initialState,
  reducers: {
    setAllCriteria: (state, action) => {
      return { ...state, ...action.payload };
    },
    setSelectedInteraction: (state, action) => {
      state.selectedInteraction = action.payload;
    },
    resetSelectedProduct: (state) => {
      state.selectedProduct = null;
    },
    clearCriteria: () => initialState,
  },
});

export const {
  setAllCriteria,
  clearCriteria,
  setSelectedInteraction,
  resetSelectedProduct
} = productCriteriaSlice.actions;

export default productCriteriaSlice.reducer;



